export default __webpack_public_path__ + "images/03844c1655dbf7c2db509bdffd0e32da.svg";